import React from 'react';
import { Space, Typography, DatePicker, Tag } from 'antd';
import { ClockCircleOutlined, FileExcelOutlined } from '@ant-design/icons';
import { Button } from 'antd';

const { Title, Text } = Typography;
const { RangePicker } = DatePicker;

const DashboardHeader = ({ periodo, setPeriodo, onExport }) => {
  return (
    <div style={{ padding: '32px 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 32 }}>
      <div>
        <Title level={2} style={{ margin: 0, fontWeight: 900, fontSize: 30, color: '#0f172a' }}>
          Controle de <span style={{ color: '#2563eb' }}>Fechamento MENSAL</span>
        </Title>
        <Text style={{ color: '#64748b', fontSize: 15 }}>Gestão operacional de níveis contábeis e pendências</Text>
      </div>
      <Space size={16}>
        <div style={{ background: '#fff', padding: '6px 16px', borderRadius: 12, border: '1px solid #e2e8f0', boxShadow: '0 2px 4px rgba(0,0,0,0.02)' }}>
          <span style={{ color: '#64748b', fontSize: 12 }}>Status Geral: </span>
          <Tag color="processing" icon={<ClockCircleOutlined style={{ fontSize: 12 }} />} style={{ borderRadius: 10, marginLeft: 8 }}>Em Fechamento</Tag>
        </div>
        <RangePicker 
            value={periodo} 
            onChange={setPeriodo} 
            picker="month" 
            format="MMMM YYYY" 
            style={{ borderRadius: 12 }}
        />
        <Button 
          icon={<FileExcelOutlined style={{ fontSize: 16 }} />} 
          onClick={onExport}
          style={{ 
            height: 40, 
            borderRadius: 12, 
            display: 'flex', 
            alignItems: 'center', 
            fontWeight: 600,
            color: '#10b981',
            borderColor: '#10b981'
          }}
        >
          Exportar Detalhes
        </Button>
      </Space>
    </div>
  );
};

export default DashboardHeader;
